import React from 'react';
import PropTypes from 'prop-types';
import ComponentsFactory from 'foundation/components-factory';
import CurrencyHelper, { currencyIsoCodes } from '../../../general/js/basket/currency-helper';
import CheckboxPanel from './checkbox-panel';
import { PRODUCT_TAG_EXTRAS } from '../../../general/js/basket/constants';
import { PRODUCT_TAG_TICKET_PLUS_EXTRA } from '../../../general/js/basket/constants';
import gtm, { ecommerceEventTypes } from '../../../general/js/gtm';


export default class ExtraPanel extends React.Component {
    constructor(props) {
        super(props);
        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onProductGroupClick({ product, productGroup }, wasSelected) {
        this.props.onSelectExtraProduct(product, productGroup, !wasSelected);

        const eventType = !wasSelected ? ecommerceEventTypes.ADD_TO_CART : ecommerceEventTypes.REMOVE_FROM_CART;

        gtm.pushEcommerceEvent(eventType, {
            currency: currencyIsoCodes.GBP,
            value: product.price,
            items: [
                {
                    item_id: product.productId,
                    item_name: `${product.tag} - ${productGroup.title}`,
                    price: product.price,
                    quantity: 1
                }
            ]
        });
    }

    renderProductGroups() {
        return this.props.extraGroup.items.map((extraItem) => {
            const { product, productGroup } = extraItem;
            const basketProductGroups = this.props.basket.productGroups;
            let isSelected = false;
            if (productGroup.id in basketProductGroups) {
                const basketProduct = basketProductGroups[productGroup.id].products.find((basketProduct) =>
                    basketProduct.id === product.id);
                if (basketProduct) {
                    isSelected = true;
                }
            }

            return <div key={productGroup.id} className="extra-panel__list-item">
                <CheckboxPanel
                    isSelected={isSelected}
                    title={productGroup.title}
                    text={this.getProductSummaryText(product)}
                    onClick={() => this.onProductGroupClick(extraItem, isSelected)}/>
            </div>;
        });
    }

    render() {
        return (
            <div className="extra-panel" ref={this.rootRef}>
                <h4 className="extra-panel__heading">{this.props.extraGroup.title}</h4>
                <div className="extra-panel__descr copy">
                    <span
                        dangerouslySetInnerHTML={{ __html: this.props.extraGroup.description }}/>&nbsp;
                    {this.props.extraGroup.linkText ? <a data-dc-component="modal-trigger"
                        className="link"
                        href={this.props.extraGroup.linkUrl}>{this.props.extraGroup.linkText}</a> : ''}
                </div>
                <div className="extra-panel__list tb-panels-list">
                    {this.renderProductGroups()}
                </div>
            </div>
        );
    }

    getProductSummaryText(product) {
        let unitText;

        switch (product.tag) {
            case PRODUCT_TAG_EXTRAS:
                unitText = 'seat';
                break;
            case PRODUCT_TAG_TICKET_PLUS_EXTRA:
                unitText = product.priceLabel;
                break;
            default:
                unitText = null;
        }

        if (unitText) {
            return `${CurrencyHelper.convertToPounds(product.price)} per ${unitText}`;
        }

        return null;
    }
}

ExtraPanel.propTypes = {
    basket: PropTypes.object,
    extraGroup: PropTypes.object,
    rootCssClass: PropTypes.string,
    onSelectExtraProduct: PropTypes.func,
};
